import { StyleSheet } from 'react-native';
import colors from '@/config/colors';

export const styles = StyleSheet.create({
  cardBody: {
    borderRadius: 12,
    borderColor: colors.newUI.therapist.blue20,
    borderWidth: 1,
    paddingTop: 0,
    paddingHorizontal: 0,
    paddingBottom: 0,
    backgroundColor: colors.newUI.therapist.primaryBlue10,
  },
  title: {
    fontSize: 16,
    fontWeight: 600,
    fontFamily: 'InterSemiBold',
    marginBottom: 12,
    color: colors.newUI.therapist.textBlue100,
  },
  detailsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  detailsText: {
    color: colors.newUI.therapist.primaryBlue80,
    fontFamily: 'InterSemiBold',
  },
  descriptionWrapper: {
    marginTop: 12,
    paddingLeft: 4,
    alignItems: 'flex-start',
    paddingVertical: 8,
    width: '100%',
    gap: 16,
    justifyContent: 'space-between',
  },
  badge: {
    alignSelf: 'flex-start',
    backgroundColor: '#E6ECF8',
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
    marginBottom: 12,
  },
  badgeText: {
    fontSize: 12,
    fontWeight: '500',
    color: colors.primary,
  },
  actionsRow: {
    borderTopColor: colors.newUI.therapist.blue20,
    borderTopWidth: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    paddingVertical: 12,
    paddingHorizontal: 12,
    overflow: 'visible',
  },
  ellipsisBtn: {
    padding: 8,
    borderRadius: 8,
    backgroundColor: 'white',
  },
  backdrop: {
    position: 'absolute',
    width: 2000,
    height: 2000,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 99,
  },
  headerWrapper: {
    backgroundColor: colors.newUI.therapist.blue20,
    borderRadius: 12,
    padding: 20,
  },

  pillWrapper: {
    justifyContent: 'flex-start',
    margin: 16,
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
  },
});
